module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/reserved_order_index-d882be52dc92f168c7893d0e00074b15.png";